import { DEFAULT_DCC_BRIDGE } from '../constants'

export const DCC_SEND_STATUS = {
  IDLE: 'idle',
  CONNECTING: 'connecting',
  SENDING: 'sending',
  SUCCESS: 'success',
  PLUGIN_NOT_RUNNING: 'pluginNotRunning',
  DCC_BUSY: 'dccBusy',
  ERROR: 'error',
}

export const initialDccBridgeState = {
  dccBridge: { ...DEFAULT_DCC_BRIDGE },
}
